import { useState } from "preact/hooks";

interface MessageInputProps {
  onSend: (content: string) => void;
  disabled?: boolean;
  maxLength?: number;
}

export function MessageInput({
  onSend,
  disabled,
  maxLength = 2000,
}: MessageInputProps) {
  const [value, setValue] = useState("");

  const handleSubmit = (e: Event) => {
    e.preventDefault();
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue("");
  };

  // Cmd/Ctrl+Enter sends; Enter alone inserts a newline only when
  // shift is held, matching common chat-app conventions.
  const handleKey = (e: KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form class="nx-input" onSubmit={handleSubmit}>
      <textarea
        class="nx-input__textarea"
        value={value}
        placeholder="Type a message…"
        rows={1}
        maxLength={maxLength}
        disabled={disabled}
        onInput={(e) => setValue((e.target as HTMLTextAreaElement).value)}
        onKeyDown={handleKey}
      />
      <button
        class="nx-input__send"
        type="submit"
        disabled={disabled || !value.trim()}
        aria-label="Send message"
      >
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M4 12L20 4l-6 16-3-7-7-1Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </form>
  );
}
